<template>
  <div>
    <TagListByCategory :account-id="accountId" />
  </div>
</template>

<script>
import components from './components';

export default {
  components,
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
};
</script>
